module.exports = __webpack_public_path__ + "assets/img/00196.a1586f84.png";